import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  personalBrandingIcon,
  socialMarketingIcon,
  payPerClickIcon,
  emailMarketinIcon,
  influencerMarketingIcon,
  analyticIcon,
} from "../../../../assets/icons/serviceIcon/index";
import SeoContentMarketingWork from "./SeoContentMarketingWork";

const items = [
  {
    name: "Keyword Research",
    text: "We identify the exact words your audience is searching for, so your content appears right when they need you.",
  },
  {
    name: "Blogs",
    text: "We craft blogs that reflect your voice, so every post builds trust and strengthens your brand.",
  },
  {
    name: "On-Page SEO",
    text: "We fine-tune your website content with the right structure and keywords, so search engines can understand and rank you better.",
  },
];

const otherService = [
  {
    icon: personalBrandingIcon,
    name: "personal Branding",
    des: "Turn your story, skills, and personality into something people remember and trust.",
    path: "/personal-branding",
  },
  {
    icon: socialMarketingIcon,
    name: "Social Media Marketing (SMM)",
    des: "Show up where your audience scrolls, shares and starts to trust you.",
    path: "/social-media-marketing",
  },
  {
    icon: payPerClickIcon,
    name: "Pay Per Click",
    des: "Get your brand seen by the right people, right when they’re searching for you.",
    path: "/pay-per-click",
  },
  {
    icon: emailMarketinIcon,
    name: "Email & CRM Marketing",
    des: "Stay in touch in a meaningful way with emails people actually want to open.",
    path: "/email-marketing",
  },
  {
    icon: influencerMarketingIcon,
    name: "Influencer & Affiliate Marketing",
    des: "Let others talk about your brand in a way that feels real and relatable.",
    path: "/influencer-marketing",
  },
  {
    icon: analyticIcon,
    name: "Analytics  & Performance Tracking ",
    des: "Know what’s working, what’s not, and what to do next without the guesswork.",
    path: "/analytic-and-performance-tracking",
  },
];

const SeoContentMarketing = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Marketing"
        description="Google loves good content. So do people. We bring the best of both - smart SEO with a human touch, making sure your brand talks, not just ranks."
        heading="SEO & Content"
      />
      <NewCommonServiceForm title="Seo & Content Marketing" items={items} />
      <SeoContentMarketingWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default SeoContentMarketing;
